<script>
const validColored = ['darkGreen', 'main'];

export default {
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    model: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    colored: {
      type: String,
      default: 'darkGreen',
      validator(value) {
        return validColored.includes(value);
      },
    },
    hint: {
      type: String,
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      let value = this.model;
      value = !this.model;
      this.$emit('change', value);
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.container, disabled && $style.disabled]", @click="toggle()")
  div(:class="[$style.group, model && $style[colored]]", :data-test="model ? 'CHECKED' : 'UNCHECKED'")
    input(type="checkbox",
      :colored="colored",
      :disabled="disabled",
      :checked="model")
  span(:class="$style.label")
    slot
    span(:class="$style.hint", v-if="hint") ({{ hint }})
</template>

<style lang="sass" module>
.container
  box-sizing: border-box
  display: inline-flex
  position: relative
  width: 100%
  line-height: 20px
  cursor: pointer
  &:hover, &:focus
    .hint
      opacity: 0.8
      transform: none

.label
  position: relative
  padding-left: 12px
  cursor: pointer
  font-size: 16px
  color: $color_text_second

.hint
  font-size: 12px
  opacity: 0
  margin-left: 10px
  display: inline-block
  transform: translateY(5px)
  transition: 0.25s ease

.group
  box-sizing: border-box
  position: relative
  border-radius: 2px
  border: 2px solid rgba(0, 0, 0, 0.54)
  height: 18px
  width: 18px
  min-width: 18px
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)
  input[type="checkbox"]
    position: absolute
    -webkit-appearance: none
    appearance: none
    left: -9999px

  &:after
    box-sizing: inherit
    content: ""
    position: absolute
    transition: transform 0.25s ease
    width: 6px
    height: 13px
    bottom: 2px
    left: 4px
    z-index: 6
    border: 2px solid $white
    border-top: 0
    border-left: 0
    opacity: 0
    transform: rotate(45deg) scale3D(0.1, 0.1, 0.1)

.darkGreen
  background-color: $color_green_dark
  border-color: $color_green_dark
  &:after
    opacity: 1
    transform: rotate(45deg) scale3d(1, 1, 1)

.main
  background-color: $color_main
  border-color: $color_main
  &:after
    opacity: 1
    transform: rotate(45deg) scale3d(1, 1, 1)

.disabled
  cursor: not-allowed
  .group
    opacity: 0.7

  .label
    opacity: 0.24
    cursor: not-allowed

</style>
